import hubListSaga from 'modules/Hub/saga/list';
import hubSoftwareListSaga from 'modules/Hub/saga/hubSoftwareList';
import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export default function* userSaga(): SagaIterator {
  yield fork(hubListSaga);
  yield fork(hubSoftwareListSaga);
}
